import { Flex as MantineFlex, FlexProps } from '@mantine/core';

export type IFlexProps = FlexProps;

/** @registry Design-layer pass-through over Mantine Flex; import this instead of @mantine/core Flex outside src/design. */
export const Flex = MantineFlex;
